import React from "react";
import { Container, Row, Col } from "reactstrap";
import { useTranslation } from 'react-i18next';

const Footer = () => {
  const {t} = useTranslation();

  return (
    <React.Fragment>
      <footer className="footer">
        <Container fluid={true}>
          <Row>
            <Col sm={6}> © {t("QUESS")} {new Date().getFullYear()}</Col>
            <Col sm={6}>
              <div className="text-sm-end d-none d-sm-block">
              Version : 1.0.0
              </div>
            </Col>
          </Row>
        </Container>
      </footer>
    </React.Fragment>
  );
};

export default Footer;
